import type { OnChangeFn, Row, SortingState } from "@tanstack/react-table"
import { getCoreRowModel } from "@tanstack/react-table"
import type { FC, RefObject } from "react"

import { useStoredGoodsReceiptPalletColumns } from "../../hooks"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { GoodsReceiptPallet } from "@/graphql/codegen/graphql"

interface StoredGoodsReceiptPalletsTableProps {
  goodsReceiptPallets: GoodsReceiptPallet[]
  isLoading: boolean
  sortingState: SortingState
  tableContainerRef: RefObject<HTMLDivElement>
  onSortingChange: OnChangeFn<SortingState>
  onQrPrint?: (pallet: GoodsReceiptPallet) => void
  onRowClick: (pallet: GoodsReceiptPallet) => void
  onScroll: () => void
}

export const StoredGoodsReceiptPalletsTable: FC<StoredGoodsReceiptPalletsTableProps> = ({
  goodsReceiptPallets,
  isLoading,
  sortingState,
  tableContainerRef,
  onSortingChange,
  onQrPrint,
  onRowClick,
  onScroll,
}) => {
  const columns = useStoredGoodsReceiptPalletColumns({ onQrPrint })

  return (
    <AerosBaseTable<GoodsReceiptPallet>
      features={{
        table: {
          stickyHeader: true,
          flexibleColumnSizing: true,
        },
        tanstackOptions: {
          data: goodsReceiptPallets,
          columns,
          manualSorting: true,
          enableSortingRemoval: false,
          getCoreRowModel: getCoreRowModel(),
          getRowId: (row) => row.goodsReceiptPalletId,
          state: {
            isLoading,
            sorting: sortingState,
          },
          onSortingChange,
        },
      }}
      slotProps={{
        container: {
          ref: tableContainerRef,
          onScroll,
        },
        bodyRow: {
          className: "hover:bg-primary-100 cursor-pointer",
          onClick: (value) => onRowClick((value as Row<GoodsReceiptPallet>).original),
        },
      }}
      noDataMessage='No stored pallets found'
    />
  )
}
